/* eslint-disable */

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  anonymous: {
    description: '',
    person_type: 'OTHER'
  },
  reporting_party: {
    full_name: '',
    phone: '',
    email: '',
    is_urgent: false,
    description: '',
    person_type: 'OTHER'
  },
  // Shared by the "identify myself" and "anonymous" forms; sent as report.workplace
  worksite: {
    work_zip_code: '',
    specific_worksite: ''
  },
  selectedReport: {}
};

const reporterSlice = createSlice({
  name: 'reporter',
  initialState: {
    anonymous: {
      description: '',
      person_type: 'OTHER'
    },
    reporting_party: {
      full_name: '',
      phone: '',
      email: '',
      is_urgent: false,
      description: '',
      person_type: 'OTHER'
    },
    worksite: {
      work_zip_code: '',
      specific_worksite: ''
    },
    selectedReport: {}
  },
  reducers: {
    setReporterValues: (state, action) => {
      const { field, value } = action.payload;
      state.reporting_party[field] = value;
    },
    setAnonymousValues: (state, action) => {
      const { field, value } = action.payload;
      state.anonymous[field] = value;
    },
    setWorksiteValues: (state, action) => {
      const { field, value } = action.payload;
      state.worksite[field] = value;
    },
    setSelectedReport: (state, action) => {
      state.selectedReport = action.payload;
    },
    rreset: () => initialState
  }
});

export const {
  setReporterValues,
  setAnonymousValues,
  setWorksiteValues,
  setSelectedReport,
  rreset
} = reporterSlice.actions;

export default reporterSlice.reducer;
